import React from 'react';
import {
  ImageBackground,
  ImageSourcePropType,
  StyleProp,
  ViewStyle,
} from 'react-native';

import TrackerTextureMap from './TrackerTextureMap';

export type TrackerTextureKeyType = keyof typeof TrackerTextureMap;

export type TrackerTextureSourceType = TrackerTextureKeyType;

export interface TrackerTextureProps {
  backgroundTexture: TrackerTextureSourceType;
  testID?: string | undefined;
  style?: StyleProp<ViewStyle>;
}

const TrackerTexture = ({
  backgroundTexture,
  testID,
  style,
}: TrackerTextureProps) => {
  const textureSource =
    TrackerTextureMap[backgroundTexture as TrackerTextureKeyType];

  return (
    <ImageBackground
      style={style}
      source={
        textureSource
          ? textureSource
          : (backgroundTexture as ImageSourcePropType)
      }
      testID={testID}
      resizeMode="cover"
    />
  );
};

export default TrackerTexture;
